import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1012e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk_add_cat" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "services" }
const _hoisted_4 = { class: "infos" }
const _hoisted_5 = { style: {"font-weight":"800","margin-right":"10px"} }
const _hoisted_6 = { style: {"margin-right":"10px"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 36 36",
  class: "circle"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-dasharray": "100, 100",
    d: "M18 2.0845\r\n                                                                                                                                                                        a 15.9155 15.9155 0 0 1 0 31.831\r\n                                                                                                                                                                        a 15.9155 15.9155 0 0 1 0 -31.831"
  })
], -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

import { ref, onBeforeMount } from "vue";
import axios from "axios";
import { toast } from 'vue3-toastify';
import autoComplete from '../inputs/autoComplete.vue'



// variable

export default /*#__PURE__*/_defineComponent({
  __name: 'addServiceView',
  setup(__props) {


const serviceCat = ref();
const allServices = ref([]);
const mainCategories = ref([]);


function deletService(service, index) {

    axios.delete(process.env.VUE_APP_SERVER_URL + '/services', { data: { id: service._id } })
        .then(function () {
            // categories.value.splice(index, 1);
            toast.success('Service supprimé!');
            allServices.value.splice(index, 1);
        })
        .catch(function (error) {
            toast.error(error);
        });
}
function addService(params) {
    axios.post(process.env.VUE_APP_SERVER_URL + '/services', params)
        .then(function (response) {
            allServices.value.push(response.data)
            toast.success('Service ajouté!');

        })
        .catch(function (error) {
            toast.error(error);
        });
}
function selectElem(catSelected) {
    serviceCat.value = catSelected._id;
    axios.get(process.env.VUE_APP_SERVER_URL + '/services/cat', {
        params: {
            cat: catSelected._id
        }
    })
        .then(function (response) {
            // handle success
            allServices.value = response.data;
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })
}
onBeforeMount(() => {



    axios.get(process.env.VUE_APP_SERVER_URL + '/services/cat', {
        params: {
            cat: 'checked'
        }
    })
        .then(function (response) {
            // handle success
            allServices.value = response.data;
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })
})


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormKit, {
      type: "form",
      "submit-label": "Ajouter un service",
      onSubmit: addService
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          name: "urlImg",
          label: "url"
        }),
        _createVNode(_component_FormKit, {
          name: "titre",
          label: "Titre du service",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          name: "description",
          label: "Description",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          type: "select",
          label: "Catégorie",
          modelValue: serviceCat.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceCat).value = $event)),
          validation: "required",
          name: "categorie"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainCategories.value, (mainCategorie, indexChild) => {
              return (_openBlock(), _createElementBlock("option", {
                key: indexChild,
                value: mainCategorie._id
              }, _toDisplayString(mainCategorie.titre), 9, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(autoComplete, {
          type: "Catégorie",
          onItemSelected: _cache[1] || (_cache[1] = (n) => selectElem(n))
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allServices.value, (service, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "card"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(service.titre), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(service.description), 1)
          ]),
          _createElementVNode("div", {
            class: "close",
            onClick: ($event: any) => (deletService(service, index))
          }, _hoisted_11, 8, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}
}

})